/**
 * MyWorkCard (P268.2) -- Home tile surfacing the count of items awaiting
 * the current user, linking to the /my-work inbox. Any logged-in user
 * (it's *their* work); self-hides while loading / on error.
 */
import { useTranslation } from "react-i18next";

import { BrassLink } from "shared/components/BrassLink";
import { Card } from "shared/components/Card";
import { useMyWork } from "shared/work/useMyWork";

export function MyWorkCard() {
  const { t } = useTranslation();
  const work = useMyWork();
  if (!work.data) return null;
  // B4 -- see MyWorkLink: what needs you, not what you can reach.
  const total = work.data.needs_you ?? work.data.total;
  const queued = work.data.total - total;
  if (work.data.reads_only) {
    // Round 20 Y1 -- the internal audit seat has no queue.
    return (
      <Card testid="my-work-card" className="space-y-2">
        <p className="font-mono text-[10.5px] uppercase tracking-[0.18em] text-ink-muted">
          {t("myWork.card.micro")}
        </p>
        <p data-testid="my-work-card-reads-only" className="text-sm text-ink-2">
          {t("myWork.readsOnly")}
        </p>
      </Card>
    );
  }

  return (
    <Card testid="my-work-card" className="space-y-2">
      <p className="font-mono text-[10.5px] uppercase tracking-[0.18em] text-ink-muted">
        {t("myWork.card.micro")}
      </p>
      <div className="flex items-baseline gap-2">
        <span
          data-testid="my-work-card-count"
          className="font-display text-2xl text-ink-1 tabular-nums"
        >
          {total}
        </span>
        <span className="text-sm text-ink-2">{t("myWork.card.awaiting")}</span>
      </div>
      {total === 0 && queued > 0 && (
        <p data-testid="my-work-card-queued" className="text-xs text-ink-muted">
          {t("myWork.card.inQueues", { count: queued })}
        </p>
      )}
      <BrassLink to="/my-work" testid="my-work-card-open" className="inline-block">
        {t("myWork.card.open")}
      </BrassLink>
    </Card>
  );
}
